/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StripeLineItemEntity } from './StripeLineItemEntity';
export type BookingWithStripeLineItemEntity = {
    id: string;
    createdAt: string;
    updatedAt: string;
    bookingStatus: BookingWithStripeLineItemEntity.bookingStatus;
    organizationId: string;
    orderId: string | null;
    meetingId: string;
    /**
     * The date and time until the booking doesn't block a spot in the meeting anymore.
     */
    exclusiveUntil: string | null;
    guestId: string | null;
    customerId: string | null;
    multipassId: string | null;
    courseGroupId: string | null;
    multipassProductId: string | null;
    priceInMillsOverride: number | null;
    replaced: boolean;
    rebateCodeId: string;
    stripeLineItem: StripeLineItemEntity | null;
    revocationBlockedAt: string | null;
    revocationBlockedReason: BookingWithStripeLineItemEntity.revocationBlockedReason | null;
};
export namespace BookingWithStripeLineItemEntity {
    export enum bookingStatus {
        RESERVED = 'RESERVED',
        CLAIMED = 'CLAIMED',
        FULFILLED = 'FULFILLED',
        REFUNDED = 'REFUNDED',
        CANCELLED = 'CANCELLED',
        CANCELLED_REFUNDED = 'CANCELLED_REFUNDED',
        REVOKED = 'REVOKED',
        WITHDRAWN = 'WITHDRAWN',
    }
    export enum revocationBlockedReason {
        WAIVER = 'WAIVER',
        MULTIPASS_USED = 'MULTIPASS_USED',
    }
}

